import Login, { LoginProps } from 'components/pages/login/login'
import { getQP } from 'lib/url'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const LoginPage = (): React.ReactElement => {
    const [loginProps, setLoginProps] = useState<LoginProps>({
        externalSSO: 'none',
        helpReturnURL: null,
        docsLocationURL: null,
    })
    const { query, isReady } = useRouter()
    useEffect(() => {
        if (!isReady) {
            return
        }
        const params: LoginProps = {
            externalSSO: 'none',
            helpReturnURL: null,
            docsLocationURL: null,
        }
        switch (query.external_sso) {
            case 'docs':
                params.externalSSO = 'docs'
                params.docsLocationURL = getQP(query.location)
                break
            case 'help':
                params.externalSSO = 'help'
                params.helpReturnURL = getQP(query.return_to)
            // no default
        }
        setLoginProps(params)
    }, [isReady, query])

    return <Login {...loginProps} />
}

export default LoginPage
